import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useCallback } from 'react';
import { useGlobalCore } from '../../../../../core/modules/global';
import { CREATE_PRICERANGE_DIALOG } from '../../../../../core/constants/dialog';
import { useCompanyCore } from '../../../../../core/modules/company';

const Header = () => {
  const { openDialog } = useGlobalCore();
  const { companyId } = useCompanyCore();

  const openCreateDialog = useCallback(() => {
    openDialog(CREATE_PRICERANGE_DIALOG);
  }, [openDialog]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Rango de Precios
          </Typography>
        </div>
        <Button
          variant="contained"
          color="secondary"
          disabled={!companyId}
          onClick={openCreateDialog}
        >
          <AddCircleOutlineOutlinedIcon />
          <span className="mx-8">Crear</span>
        </Button>
      </div>
    </div>
  );
};

export default Header;
